import { defineCustomElement, defineCustomElementLoader } from "../../service/feature.js";
import { REGISTRY_ELEMENT, RESOURCE_HIDDEN } from "../resource.js";
import { NamespaceUtility } from "./namespace.js";
import { defineCustomWidget } from "../../service/widget.js";
export class FeatureUtility extends NamespaceUtility {
    /**
     * @deprecated use isHidden
     */
    get isEnabled() {
        return !this[REGISTRY_ELEMENT][RESOURCE_HIDDEN];
    }
    get isHidden() {
        return !!this[REGISTRY_ELEMENT][RESOURCE_HIDDEN];
    }
    /**
     * @param {import("../resource.js").ConfigCallback | null} callbackConfig
     *
    set config(callbackConfig) {
      setConfig(this[REGISTRY_ELEMENT], callbackConfig)
      callConfig(this[REGISTRY_ELEMENT]);
    }
  
    get config() {
      return this[REGISTRY_ELEMENT][RESOURCE_CONFIG] ?? null;
    }*/
    /**
     * @param {string} name
     * @param {typeof import('../widget.js').Widget} CustomWidget
     */
    defineWidget(name, CustomWidget) {
        defineCustomWidget(this[REGISTRY_ELEMENT], name, CustomWidget);
    }
    /**
     * @param {string} name
     * @param {typeof HTMLElement} Element
     */
    defineElement(name, Element) {
        defineCustomElement(this[REGISTRY_ELEMENT], name, Element);
    }
    /**
     * @param {string} name
     * @param {(name: string) => Promise<typeof HTMLElement>} loader
     */
    defineElementLoader(name, loader) {
        defineCustomElementLoader(this[REGISTRY_ELEMENT], name, loader);
    }
}
